<template>
  <div class="container">
    <div class="title">忘记密码</div>
    <div class="weui-cells weui-cells_form">
        <div class="weui-cell weui-cell_select weui-cell_select-before">
            <div class="weui-cell__hd">
                
                <select class="weui-select" name="select">
                    <option value="1">🇦🇺+61</option>
                </select>
            </div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="tel" pattern="[0-9]" :disabled="cd > 0" placeholder="请输入手机号" v-model="phone" >
            </div>
            <div class="weui-cell__ft">
                <button class="weui-vcode-btn" @click="getYzm()" v-bind:class="{ disabled:cd>0 }">{{ cd>0 ? cd+'秒' : '获取验证码' }}</button>
            </div>
        </div>
        <div class="weui-cell weui-cells_form">
            <div class="weui-cell__hd">
                <label class="weui-label">验证码</label>
            </div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="number" pattern="[0-9]{4}" placeholder="请输入4位数字验证码" v-model="yzm" maxlength="4" ref="yzm"/>
            </div>
        </div>

        <div class="weui-cell weui-cells_form">
            <div class="weui-cell__hd">
                <label class="weui-label">新密码</label>
            </div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="password" placeholder="请输入长度8位以上新密码" v-model="password" />
            </div>
        </div>
    </div>
    <br>
    <div class="btn-box">
      <div class="btn active" @click="resetSubmit()">保存新密码</div>
    </div>

    <div class="warning" v-show="yzmError()">⚠️获取验证码失败：{{ymzRes.data}}</div>
    <div class="warning" v-show="ajaxError()">⚠️保存出错：{{regRes.data}}</div>
    <div class="warning" v-show="this.localError.length">⚠️保存出错：{{localError.toString()}}</div>


    <transition name="fade">
        <div id="loadingToast" v-show="isToast">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在发送数据</p>
            </div>
        </div>
    </transition>



  </div>
</template>

<script>

import qs from 'qs'

export default {
  name: 'forgetpw',
  data () {
    return {
      phone:'',
      yzm:'',
      password:'',
      ymzRes:{
        data:'',
        error_code:''
      },
      regRes:{
        data:'',
        error_code:''
      },
      localError: [],
      yzmCD:false,
      isToast:false,
      endCD:0,
      cd:0,
    }
  },
  methods: {
    //获取验证码
    getYzm(){
      //如果还在倒计时，禁止点击
      if(this.cd){
        return false;
      }
      //本地检测电话格式
      if (!this.phone) {
        alert("请填写手机号");
      } else if (this.phone.length!=9&&this.phone.length!=10&&this.phone.length!=11) {
        alert("请输入10位数字手机号");
      }
      else{
        let that = this;
        //「正在发送数据」弹窗提醒开启
        that.isToast = true;
        //重置验证码报错，清空报错提示
        that.ymzRes.error_code = 0;
        //让验证码框自动聚焦
        that.$refs.yzm.focus();
        //post请求发送验证码
        this.axios.post(this.apiURL()+'/globals/sendCode', 
          qs.stringify(
            {
              phone: this.phone,
              type:2
            }
          )
        )
        .then(function (response) {
          //「正在发送数据」弹窗提醒关闭
          that.isToast = false;
          //api返回的数据录入本地对象
          that.ymzRes = response.data;
          //如果发送成功，开启倒计时，240秒
          if(that.ymzRes.error_code==0){
            that.endCD = Date.parse(new Date())/1000+180;
            that.smsInterval = window.setInterval(that.countdown,1000);
          }
        })
        .catch(function (error) {
          that.isToast = false;
        });
      }
    },
    //提交重置
    resetSubmit(){
      //本地验证表格函数
      if(this.checkResetSubmit()){
        let that = this;
        //「正在发送数据」弹窗提醒开启
        that.isToast = true;
        this.axios.post(this.apiURL()+'/globals/resetPass', 
          qs.stringify(
            {
              account_name: this.phone,
              yzm: this.yzm,
              password: this.password
            }
          )
        )
        .then(function (response) {
          //「正在发送数据」弹窗提醒关闭
          that.isToast = false;
          //api返回的数据录入本地对象
          that.regRes = response.data;
          //如果重置成功，跳转去重置成功页面
          if(that.regRes.error_code==0){
            alert("重置密码成功，请使用新密码登录")
            let url = "/login";
            if (that.phone){
              url = url + "?phone=" + that.phone;
            }
            that.$router.push(url);
          }
          console.log(response.data)
        })
        .catch(function (error) {
          that.isToast = false;
        });
      }
    },
    //本地表格检查
    checkResetSubmit(){
      this.localError = [];

      if (!this.phone) {
        this.localError.push("请填写手机号");
      } else if (this.phone.length!=9&&this.phone.length!=10&&this.phone.length!=11) {
        this.localError.push("请输入10位数字手机号");
      }
      if (!this.yzm) {
        this.localError.push('请填写验证码');
      } else if (this.yzm.length!=4) {
        this.localError.push("请输入4位数字验证码");
      }
      if (!this.password) {
        this.localError.push('请输入8~20位字符密码');
      } else if (this.password.length<8 || this.password.length>20) {
        this.localError.push("请输入8~20位字符密码");
      }
      
      if (!this.localError.length) {
        return true;
      }
      else{
        return false;
      }
    },
    yzmError(){
      if(this.ymzRes.error_code!=0){
        return true;
      }
    },
    ajaxError(){
      if(this.regRes.error_code!=0){
        return true;
      }
    },
    //当倒计时为0，停止倒计时
    countdown(){
      this.cd = this.endCD - Date.parse(new Date())/1000;
      if(this.cd <=0){
        clearInterval(this.smsInterval);
      }
    },
  },
  components: {
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  created() {
    if(this.checkLogin()){
      this.$router.push('/profile');
    }
    if(this.$route.query.phone){
      this.phone = this.$route.query.phone;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.btn{
  margin-top:12px;
}

.title{
  margin:5vmax 0 2vmax 0;
  font-size:2.2em;
}

.terms{
  font-size:0.8em;
  color:#555;
  text-align:center;
  margin-top:28px;
}

.warning{
  color:#555;
  text-align:center;
  margin-top:20px;
  padding:0 20px;
}


.jump-link{
  color:#fe9567;
  text-align:center;
  margin-top:50px;
  text-shadow: 1px 1px 2px #fff
}

.flag{
    width:21px;
    line-height:14px;
    vertical-align:top;
    margin-left:18px;
    margin-top:15px;
}

.container /deep/{

  .weui-cell_select-before{
    padding-right:0
  }

  .weui-vcode-btn{
    color:#fe9567;
    width:110px;
  }

  .weui-vcode-btn.disabled{
    color:#999;
  }

  .weui-cells:after, .weui-cells:before, .weui-cell:before, .weui-cell:after{
    z-index:0;
  }

}

.portal{
  text-align:center;
  margin-bottom:30px;
  div{
    display:inline-block;
    font-size:1.4em;
  }
  .portal-login{
    padding:6px 50px;
    box-sizing:border-box;
    border-left:1px solid #bbb;
  }
  .portal-reg{
    border-bottom:4px solid #fe9567;
    margin:0 40px;
    padding:2px 10px;
    box-sizing:border-box;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/user/forget-password.vue